export default "__VITE_ASSET__LOSN_EoA__"